<template>
  <div class="webinar-buttons">
    <v-button v-for="button in buttons" :key="button.id" :href="button.href"
              @click="clickButton(button)">
      {{ button.label }}
    </v-button>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, onBeforeUnmount, PropType, ref,
} from 'vue'
import axios from 'axios'
import { Button, Button as B } from '@/types/webinar.d'
import VButton from '@/vue/public/VButton.vue'
import periodic from '@/scripts/periodic'
import { request } from '@/scripts/combinedRequest'

export default defineComponent({
  name: 'Buttons',
  props: {
    scheduleId: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  components: {
    VButton,
  },
  setup(props) {
    const buttons = ref<Button[]>([])

    onBeforeUnmount(periodic(5000, async () => {
      buttons.value = await request<Button[]>('buttons').then((data) => data.filter((b: B) => b.visibility))
    }))

    return {
      buttons,
      clickButton(button: Button) {
        return axios.post(`/schedule/${props.scheduleId}/click-button`, {
          title: button.label,
          href: button.href,
        }).catch(() => false)
      },
    }
  },
})
</script>

<style lang="stylus">
.webinar-buttons
  display flex
  flex-wrap wrap
</style>
